import segmentedStyle from "../templates/Segmented.style";
var segmentedData = {
  name: 'segmented',
  data: [{
    borderColor: '#dee2e6'
  }],
  extraTemplate: {
    pro: segmentedStyle
  }
};
export default segmentedData;